import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "theme"],
    _excluded2 = ["text", "key"];

/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import Button from '@atlaskit/button/custom-theme-button';
import { createTheme, useGlobalTheme } from '@atlaskit/theme/components';
import { borderRadius, gridSize as getGridSize, layers } from '@atlaskit/theme/constants';
import { h600 } from '@atlaskit/theme/typography';
import { DialogActionItem, DialogActionItemContainer } from '../styled/dialog';
var gridSize = getGridSize(); // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage

var lightH600Styles = css(h600({
  theme: {
    mode: 'light'
  }
})); // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage

var darkH600Styles = css(h600({
  theme: {
    mode: 'dark'
  }
}));
var Container = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  return (// eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
    jsx("div", _extends({
      css: theme,
      ref: ref
    }, props), children)
  );
});
var bodyStyles = css({
  display: 'flex',
  padding: "".concat(gridSize * 2, "px ").concat(gridSize * 2.5, "px"),
  flexDirection: 'column'
}); // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage

var headingStyles = css({
  color: 'inherit'
});
var defaultHeaderStyles = css({
  display: 'flex',
  paddingBottom: "".concat(gridSize, "px"),
  alignItems: 'baseline',
  justifyContent: 'space-between'
});

var DefaultHeader = function DefaultHeader(_ref2) {
  var children = _ref2.children;
  return jsx("div", {
    css: defaultHeaderStyles
  }, children);
};

var defaultFooterStyles = css({
  display: 'flex',
  paddingTop: "".concat(gridSize, "px"),
  alignItems: 'center',
  justifyContent: 'space-between'
});

var DefaultFooter = function DefaultFooter(_ref3) {
  var children = _ref3.children;
  return jsx("div", {
    css: defaultFooterStyles
  }, children);
};

var Theme = createTheme(function () {
  return {
    container: {
      overflow: 'auto',
      borderRadius: "".concat(borderRadius(), "px"),
      height: 'fit-content',
      zIndex: "".concat(layers.spotlight() + 1)
    }
  };
});
/**
 * __Card__
 *
 * A card base for the spotlight card. The external `SpotlightCard` wraps this component.
 *
 * @internal
 */

var Card = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var _ref4$actions = _ref4.actions,
      actions = _ref4$actions === void 0 ? [] : _ref4$actions,
      actionsBeforeElement = _ref4.actionsBeforeElement,
      children = _ref4.children,
      _ref4$components = _ref4.components,
      components = _ref4$components === void 0 ? {} : _ref4$components,
      image = _ref4.image,
      heading = _ref4.heading,
      headingAfterElement = _ref4.headingAfterElement,
      theme = _ref4.theme,
      testId = _ref4.testId;
  var _components$Header = components.Header,
      Header = _components$Header === void 0 ? DefaultHeader : _components$Header,
      _components$Footer = components.Footer,
      Footer = _components$Footer === void 0 ? DefaultFooter : _components$Footer;

  var _useGlobalTheme = useGlobalTheme(),
      mode = _useGlobalTheme.mode;

  return jsx(Theme.Provider, {
    value: theme
  }, jsx(Theme.Consumer, null, function (_ref5) {
    var container = _ref5.container;
    return (// eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
      jsx(Container, {
        theme: container,
        ref: ref,
        "data-testid": testId
      }, typeof image === 'string' ? jsx("img", {
        src: image,
        alt: ""
      }) : image, jsx("div", {
        css: bodyStyles
      }, heading || headingAfterElement ? jsx(Header, null, jsx("h4", {
        css: [mode === 'light' ? lightH600Styles : darkH600Styles, headingStyles]
      }, heading), headingAfterElement) : null, children, actions.length > 0 || actionsBeforeElement ? jsx(Footer, null, actionsBeforeElement || jsx("span", null), jsx(DialogActionItemContainer, null, actions.map(function (_ref6, idx) {
        var text = _ref6.text,
            key = _ref6.key,
            rest = _objectWithoutProperties(_ref6, _excluded2);

        return jsx(DialogActionItem, {
          key: key || (typeof text === 'string' ? text : "".concat(idx))
        }, jsx(Button, rest, text));
      }))) : null))
    );
  }));
});
export default Card;